import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { map, Observable } from 'rxjs';

import * as DataAccessSearchPageActions from './data-access-search.page.actions';

import { SearchResult } from '../search-results/data-access-search.models';

@Injectable()
export class DataAccessSearchPageFacade {
  filterChip$: Observable<{ filterType: string; filterId: string }>;
  overlayToggled$: Observable<boolean>;

  constructor(private readonly store: Store, private actions$: Actions) {
    this.filterChip$ = this.actions$.pipe(ofType(DataAccessSearchPageActions.filterChipClicked));
    this.overlayToggled$ = this.actions$.pipe(
      ofType(DataAccessSearchPageActions.overlayToggled),
      map((action) => action.status)
    );
  }

  shareButtonClicked(network: string, item: SearchResult, fairId: string, pageContext: string) {
    this.store.dispatch(
      DataAccessSearchPageActions.shareButtonClicked({
        network: network,
        item: item,
        fairId: fairId,
        pageContext: pageContext,
      })
    );
  }

  shareDialogOpened(item: SearchResult, pageContext: string, context: string) {
    this.store.dispatch(
      DataAccessSearchPageActions.shareDialogOpened({
        contentType: item.type,
        pageContext: pageContext,
        context: context,
        item: item,
      })
    );
  }

  filterChipClicked(filterType: string, filterId: string) {
    this.store.dispatch(
      DataAccessSearchPageActions.filterChipClicked({
        filterType: filterType,
        filterId: filterId,
      })
    );
  }

  overlayToggled(status: boolean) {
    this.store.dispatch(DataAccessSearchPageActions.overlayToggled({ status }));
  }
}
